import { PlayersToolbar } from "@/components/organisms/PlayersToolbar/PlayersToolbar";
import { BREAKPOINTS } from "@/settings";
import { evolvedPlayersSelector } from "@repo/shared/redux";
import { matchesSearch } from "@repo/shared/utils";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "usehooks-ts";

import { MyEvolvedTabs } from "./MyEvolvedTabs";
import { SavedEvoPlayers } from "./SavedEvoPlayers";

/** Saved evolutions: search only, no role or sort. */
export const SavedEvoPlayersPage = () => {
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);
  const [searchTerm, setSearchTerm] = useState("");
  const { savedEvolutionPlayers, savedEvolutionPlayersStatus } = useSelector(
    evolvedPlayersSelector,
  );

  const filteredSavedEvolutionPlayers = savedEvolutionPlayers.filter((p) =>
    matchesSearch(p.player.name, searchTerm),
  );

  return (
    <>
      <PlayersToolbar
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        handleToolbarAction={() => {}}
        isMobile={isMobile}
        hasFilters={false}
        showPlayerRole={false}
        pageType="my-evolutions"
        quickFilters={<MyEvolvedTabs />}
      />
      <div className="mx-auto flex min-h-[60vh] w-full max-w-content flex-col gap-y-4 px-3 pt-3 pb-24 large:px-16 touch-device:px-4">
        <SavedEvoPlayers
          savedEvolutionPlayers={filteredSavedEvolutionPlayers}
          savedEvolutionPlayersStatus={savedEvolutionPlayersStatus}
        />
      </div>
    </>
  );
};
